module.exports = __webpack_public_path__ + "img/action_Help.b93fab47.svg";